import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

//const
import { QUERY_KEYS } from 'consts/queryKeys';
//custom hooks
import { useCustomToast } from 'hooks';
//services
import { deleteCalculationStatement } from 'modules/accommodations/features/reservations/api';

export const useDeleteCalculationStatementMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  const { mutate, isLoading } = useMutation(deleteCalculationStatement, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RENTALS_CALCULATION_STATEMENTS);
      successToast(t('Statement successfully deleted.'));
    },
    onError: () => errorToast(),
  });

  return {
    mutate,
    isLoading,
  };
};
